module.exports = __webpack_public_path__ + "static/media/logo-ferrari.2221ceb9.png";